import FormatNumberInput from './FormatNumberInput';

export default FormatNumberInput;
